// extracted by mini-css-extract-plugin
export default {"receiptPDF":"ViewPDF_receiptPDF__UnZ7O","receiptPDFBlocker":"ViewPDF_receiptPDFBlocker__7llco"};